<template>
  <div class="app-container" ref="body">
    <div class="app-body">
      <van-nav-bar
        title="报名信息"
        left-text="返回"
        left-arrow
        fixed
        @click-left="goBack('/user')"
      />
      <van-pull-refresh
        v-model="isLoading"
        success-text="刷新成功"
        @refresh="onRefresh"
        style="padding-top:46px;"
      >
        <van-cell-group v-if="obj.status > 0" title="报名须知">
          <div class="order-tips" v-html="obj.aftercontent"></div>
        </van-cell-group>
        <van-cell-group title="报名信息">
          <van-cell title="状态">
            <van-tag v-if="!obj.status" color="#aaa" text-color="#fff">待付款</van-tag>
            <van-tag v-if="obj.status == 1" plain type="primary">已支付</van-tag>
            <van-tag v-if="obj.status == 2" plain type="success">已报名</van-tag>
          </van-cell>
          <van-cell title="报名项目" :value="obj.title" />
          <van-cell title="报名科目" :value="obj.coursename" />
          <van-cell title="姓名" :value="stu.name" />
          <van-cell title="性别" :value="showSex(stu.sex)" />
          <van-cell title="学号" :value="stu.xh" />
          <van-cell title="身份证号" :value="stu.sfzh" />
          <van-cell title="手机号" :value="stu.mobile" />
          <van-cell title="QQ" :value="stu.qq" />
          <van-cell title="微信" :value="stu.weixin" />
          <van-cell title="校区" :value="stu.xqname" />
          <van-cell title="学院" :value="stu.xyname" />
          <van-cell title="拟报专业" :value="stu.bmzy" />
          <van-cell title="学生证或一卡通照片">
            <van-image :src="imgPath(stu.xszpic)" />
          </van-cell>
        </van-cell-group>
      </van-pull-refresh>
      <div v-if="!obj.status" class="order-btns">
        <div class="order-edit">
          <van-button round block plain type="primary" @click="$router.push('/signup-edit/'+ id)">
            修改信息
          </van-button>
        </div>
        <div class="order-pay">
          <van-button v-if="obj.amount" round block type="info" @click="doPay(obj)">
            <span class="prices">
              <span class="price" v-html="webPrice(obj.amount)"></span>
            </span>
              去支付
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import siteMixin from '@/utils/site-mixin';
export default {
  components: {
  },
  mixins: [siteMixin],
  props: {
    id: String
  },
  data() {
    return {
      error: false,
      isLoading: false,
      obj: {},
      stu: {}
    }
  },
  computed: {
    ...mapGetters([]),
  },
  watch: {
    id() {
      this.loadData();
    }
  },
  created () {
    this.loadData();
  },
  mounted () {
  },
  methods: {
    loadData(callback) {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.obj = {};
      this.stu = {};
      this.doPost({
        url: 'site/home/order/'+ this.id,
        data: {},
        okcb: (json) => {
          this.obj = Object.assign({}, json.obj);
          this.stu = Object.assign({}, json.stu);
          if (callback) {
            callback();
          }
        },
        cb: () => {
          this.$nextTick(() => this.isLoading = false);
        },
        errcb: () => {
          this.error = true;
        }
      });
    },
    onRefresh() {
      this.isLoading = false;
      this.loadData(() => {
        this.$toast('刷新成功');
      });
    },
    doPay(item) {
      // 如果未登录，或缺失openid【微信浏览器中】，则登录
      if (!this.member.id || !this.member.openid) {
        this.login();
        return;
      }
      this.Toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      this.doPost({
        url: 'site/signup/wxpay2/'+ item.id,
        data: {openid: this.member.openid},
        okcb: (json) => {
          // 如果需要登录获取openid
          if (json.needopenid) {
            this.login();
            return;
          }
          if (json.ok) {
            setTimeout(() => {
              this.Toast('已完成支付！');
            }, 20);
            item.status = json.status;
            return;
          }
          let params = {goods: { name: item.title, amount: item.amount }, orderid:json.orderid };
          if (json.code_url) {
            params.codeUrl = json.code_url;
          } else {
            params.wxpayparams = JSON.parse(json.payparams);
          }
          // 支付界面
          this.payforward = true;
          this.$router.push({ name:'signup-pay', params: params });
        },
        cb: () => {
          this.Toast.clear();
        },
        errcb: (json) => {
          if (json && json.message) {
            setTimeout(() => {
              this.Toast.fail(json.message);
            }, 10);
          }
        }
      });
    },
  }
}
</script>
<style lang="less" scoped>
.app-body {
  padding-bottom:5.2rem;
  /deep/ .order-tips {
    padding:1rem;
    line-height:1.75;
    img {
      max-width: 100%;
    }
  }
}
.order-btns {
  position:fixed;
  left:1rem;
  bottom: 1rem;
  right:1rem;
  .flex-center-v();
  /deep/ .van-button--normal {
    .fontsize(1.2rem);
  }
  .order-edit, .order-pay {
    flex-grow:1;
  }
  .order-pay {
    margin-left:1rem;
    width:50%;
    .flex-center-v();
  }
  .prices {
    display: inline-block;
    .price {
      display: inline-block;
      color: #ff6600;
      .fontsize(1.2rem);
      small {
        .fontsize(.85rem);
      }
    }
  }
}
</style>